import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledMerchandisingTileSkinny = styled.div<{ openInaNewTab: boolean; fontIcon: string }>`
  .merchandising-tile-skinny {
    &__link {
      border-radius: ${toRem(14)};
      border: ${toRem(1)} solid #c4c4c4;
      &.icon-arrow-right-external,
      &.icon-arrow-right {
        &::before {
          min-height: ${toRem(24)};
          right: ${toRem(16)};
          position: absolute;
        }
      }
    }

    &__content {
      max-width: 75%;
    }

    &__heading,
    &__description p {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    &__image {
      max-width: ${toRem(56)};
    }

    &__description p {
      margin: 0;
    }
  }
`;
